import React from 'react'
import ModalDemo from '../demos/modal'

const ModalContainer = () => {
  return <ModalDemo />
}

export default ModalContainer
